<template>

    <select
        class="f1 input-select my-4px mx-12px sm-mx-0"
        :id="name"
        :name="name"
        v-model="value">
        <option value="all">All {{ formatName }}</option>
        <option
            v-for="option in options"
            :key="option.term_id"
            :value="option.slug">{{ option.name }}</option>
    </select>

</template>

<script>

    import {mapActions} from "vuex";

    export default {
        name: 'FilterSelect',
        props: {
            postType: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            options: {
                type: Array,
                required: true
            },
        },

        computed: {
            formGetter() {
                return this.$store.getters[`Forms/form`](this.postType);
            },
            value: {
                set(value) {
                    this.updateFormValue({postType: this.postType, key: this.name, value, filter: true});
                },
                get() {
                    return this.formGetter['filters'][this.name];
                }
            },
            formatName() {
                let name = this.name;
                return name.split('_').join(' ');
            }
        },

        methods: {
            ...mapActions('Forms', ['updateFormValue']),
        }
    }

</script>
